import { connect } from 'react-redux';
import { API_URL, TUPAS_URL } from './application';
import { trackEvent } from '../utils/gtm';

const LOGIN_CUSTOMER_URL =  API_URL+'api/Authentication/Login';
const LOGIN_TUPAS_URL = API_URL + "api/Authentication/TupasLogin?TupasId=";
const TUPAS_TOKEN_URL = API_URL + "api/AuthorizeMLE/GetTupasLoginToken";

// Nets
const CREATE_LOGIN_TOKEN_URL = API_URL + "api/AuthorizeNets/GetNetsLoginTokenForService?serviceEnum={serviceId}&authenticationContext={authenticationContext}&id={applicationId}";

// Signicat
//const CREATE_LOGIN_TOKEN_URL = API_URL + "api/AuthorizeMLE/GetTupasLoginTokenForService?serviceEnum=";

const CHANGE_PASSWORD_URL =  API_URL+'api/Authentication/ChangePassword';
const CHANGE_ENTERED_PASSWORD_URL =  API_URL+'api/Authentication/ChangeEnteredPassword';

const CREATE_USER_URL =     API_URL+'api/Authentication/New';
const TOKEN_URL =     API_URL+'api/Authentication/RefreshToken/';
const AUTHENTICATION_SESSION_URL = API_URL+'api/Authorize/AuthenticationSession?id='

export const LOGINSTATE_RESETPASSWORD_SUCCESS = "LOGINSTATE_RESETPASSWORD_SUCCESS";
export const LOGINSTATE_RESETPASSWORD_ENTERED_SUCCESS = "LOGINSTATE_RESETPASSWORD_ENTERED_SUCCESS";

export const LOGINSTATE_RESETPASSWORD_ISFETCHING = "LOGINSTATE_RESETPASSWORD_ISFETCHING";
export const LOGINSTATE_RESETPASSWORD_ENTERED_ISFETCHING = "LOGINSTATE_RESETPASSWORD_ENTERED_ISFETCHING";

export const LOGINSTATE_LOGGED_IN_SUCCESS = 'LOGINSTATE_LOGGED_IN_SUCCESS';
export const LOGINSTATE_LOGOUT = 'LOGINSTATE_LOGOUT';

export const TUPAS_ADDUPDATE_TOKEN = "TUPAS_ADDUPDATE_TOKEN";

export const CREATE_LOGIN_TOKEN_REQUEST = "CREATE_LOGIN_TOKEN_REQUEST";
export const CREATE_LOGIN_TOKEN_RETRIEVE = "CREATE_LOGIN_TOKEN_RETRIEVE";
export const CREATE_LOGIN_TOKEN_ERROR = "CREATE_LOGIN_TOKEN_ERROR";

export const RESET_LOGIN_TOKEN = "RESET_LOGIN_TOKEN";

export function logoutUser() {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            try {
                dispatch({type: LOGINSTATE_LOGOUT, data:''});
                dispatch({type: 'REQUEST_CLEAN_LOGIN'});
                resolve("Logout successful"); // Resolve the promise when logout actions are dispatched
            } catch (error) {
                reject(error); // Reject the promise if any error occurs
            }
        });
    }
}

export function GetAuthenticationSession(sessionId) {
    return dispatch => {
        console.log("getting authentication session");
        console.log(sessionId);

         return fetch(AUTHENTICATION_SESSION_URL + sessionId).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : 'EXTERNAL_AUTHENTICATION_SUCCESS', data: response })
                    },                    
            error => {
                throw error;
            }                                
        )}   
}

export function fetchJWTToken() {   
    console.log("in fetchJWTToken");
    return (dispatch, getState) => {
        console.log("dispatching Refreshing Token");
        dispatch({type: 'REFRESHING_TOKEN'});
        var rToken = getState().auth.refreshToken;
        return fetch(API_URL+'api/Authentication/RefreshToken?rToken='+rToken)
        .then (
            response => {
                if (!response.ok) {
                    console.log("no token");
                }

                return response.json().then (
                    response => {    
                        console.log("got new token");
                        console.log(response);
                        dispatch({type: 'DONE_REFRESHING_TOKEN', response});
                        return response;                        
                    }                     
                )                                
        })        
    }
}

export function saveAppToken() {   
}

export function changeEnteredPassword(loginData) {
    return (dispatch) => {
        dispatch({type: LOGINSTATE_RESETPASSWORD_ENTERED_ISFETCHING});
        /*
        const token = getState().authentication.token; 
        const username = getState().customer.email;
        const userPassword = getState().customer.password;
        */
        return fetch(CHANGE_ENTERED_PASSWORD_URL, {
            method: 'POST',
            headers: {           
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                Token: loginData.token,
                Password: loginData.password
              })
        }). then (
            response => {
                if (!response.ok) {
                }

                return response.json().then (
                    response => {
                        return dispatch ({ type: LOGINSTATE_RESETPASSWORD_ENTERED_SUCCESS, result: true})
                    }                     
                )                                
        })
    }
}

export function changePassword(loginData) {
    return (dispatch) => {
        dispatch({type: LOGINSTATE_RESETPASSWORD_ISFETCHING});
        /*
        const token = getState().authentication.token; 
        const username = getState().customer.email;
        const userPassword = getState().customer.password;
        */
        return fetch(CHANGE_PASSWORD_URL, {
            method: 'POST',
            headers: {           
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                UserName: loginData.username,
                Password: loginData.password
              })
        }). then (
            response => {
                if (!response.ok) {
                }

                return response.json().then (
                    response => {
                        return dispatch ({ type: LOGINSTATE_RESETPASSWORD_SUCCESS, result:true})
                    }                     
                )                                
        })
    }
}



export function loginUser(loginData) {
    return (dispatch) => {
        dispatch({type: 'LOGINSTATE_ISFETCHING', data:''});
        /*
        const token = getState().authentication.token; 
        const username = getState().customer.email;
        const userPassword = getState().customer.password;
        */
        return fetch(LOGIN_CUSTOMER_URL, {
            method: 'POST',
            headers: {           
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                UserName: loginData.username,
                Password: loginData.password
              })
        }). then (
            response => {
                if (!response.ok) {
                    return dispatch ({ type: 'LOGINSTATE_LOGGED_IN_FAILURE',loginData:{loginResult: false, token:''}});
                }

                return response.json().then (
                    response => {
                        dispatch({ type: 'AUTHENTICATION_ADDUPDATE_TOKEN', data: response })
                        
                        // Track GTM event for successful non-admin logins
                        // role 0 = customer, role 1 = app/borrower, role 2 = admin
                        if (response.type !== 2) {
                            trackEvent('kr_process_event', {
                                "process_name": "portal_login",
                                "process_step": "portal_login"
                            });
                        }
                        
                        return dispatch ({ type: LOGINSTATE_LOGGED_IN_SUCCESS, loginData:{loginResult: true, username: loginData.username, role: response.type, requireTupas: response.requireTupas, customer: response.cust}})
                    }                     
                )                                
        })
    }
}

export function getTupasToken() {
  return (dispatch) => {
    return fetch(TUPAS_TOKEN_URL, {
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      return response.json().then((response) => {
        dispatch({ type: TUPAS_ADDUPDATE_TOKEN, data: response });
      });
    });
  };
}

export function tryLoginTupas(token) {
  return (dispatch) => {
    dispatch({ type: "LOGINSTATE_ISFETCHING", data: "" });
    /*
        const token = getState().authentication.token; 
        const username = getState().customer.email;
        const userPassword = getState().customer.password;
        */
    return fetch(LOGIN_TUPAS_URL + token, {
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (!response.ok) {
        return dispatch({
          type: "LOGINSTATE_LOGGED_IN_FAILURE",
          loginData: { loginResult: false, token: "" },
        });
      }

      return response.json().then((response) => {
        dispatch({ type: "AUTHENTICATION_ADDUPDATE_TOKEN", data: response });
        
        // Track GTM event for successful non-admin logins
        // role 0 = customer, role 1 = app/borrower, role 2 = admin
        if (response.type !== 2) {
            trackEvent('kr_process_event', {
                "process_name": "portal_login",
                "process_step": "portal_login_completed"
            });
        }
        
        return dispatch({
          type: LOGINSTATE_LOGGED_IN_SUCCESS,
          loginData: {
            loginResult: true,
            username: response.username,
            role: response.type,
            customer: response.cust,
          },
        });
      });
    });
  };
}

export const createLoginToken = (serviceId, authContext, applicationId = null) => {
  return (dispatch, getState) => {
    dispatch({
      type: CREATE_LOGIN_TOKEN_REQUEST,
      payload: {
        params: { serviceId, authContext, applicationId },
      },
    });


    //replace values in url
    const url = CREATE_LOGIN_TOKEN_URL.replace("{serviceId}", serviceId).replace("{authenticationContext}", authContext).replace("{applicationId}", applicationId || '');

    return fetch(url, {
      method: "GET",
    })
      .then((response) =>
        response.json().then((result) => {
          dispatch({
            type: response.ok
              ? CREATE_LOGIN_TOKEN_RETRIEVE
              : CREATE_LOGIN_TOKEN_ERROR,
            payload: {
              [response.ok ? "data" : "error"]: response.ok
                ? { loginToken: result }
                : new Error(JSON.stringify(result)),
            },
          });

          // Redirect if token retrieval is successful
          if (response.ok) {
            // Replace this with your redirect logic
            // For example: window.location.href = '/dashboard';

            // window.location.href =
            // "https://vertaislaina.sandbox.signicat.com/auth/open/connect/authorize?" +
            // result;

            // Track GTM event for starting Tupas authentication
            trackEvent('kr_process_start', {
                "process_name": "portal_login",
                "process_step": "portal_login_start"
            });

            window.location.href = (TUPAS_URL +  result);

      
          }
        })
      )
      .catch((error) =>
        dispatch({
          type: CREATE_LOGIN_TOKEN_ERROR,
          payload: { error },
        })
      );
  };
};

export const resetLoginToken = (serviceId) => {
  return (dispatch, getState) => {
    dispatch({
      type: RESET_LOGIN_TOKEN,
    });
  };
};
